// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"dbe460a1","233":"3c588029","259":"bf15aa72","522":"8542c630","533":"846df031","563":"7073f64f","843":"1913dbfe","897":"cf51ea54","906":"c2093aeb","957":"64552564"}[chunkId] + ".chunk.js";
};